import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/customer-refund-shipment/constants'


const propTypes = {
  status: PropTypes.string
}

const defaultProps = {
  status: 'pending'
}

/**
 * @param {string} status
 */
const CustomerRefundShipmentStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.PENDING] : 'warning',
    [STATUS.SHIPPED] : 'success'
  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerRefundShipmentStatusBadge.propTypes    = propTypes
CustomerRefundShipmentStatusBadge.defaultProps = defaultProps

export default CustomerRefundShipmentStatusBadge
